import React from 'react'
import Style from './Header.css'
import Button from '../Button/Button'
import Wordmark from '../../assets/ua.svg'

const Header = (props) => {
  return (
    <div className="header bg-color-arizona-blue">
      <header>
        <div className="container">
          <a
            href="https://arizona.edu"
            className="logo-link"
            id="the-university-of-arizona-header"
            rel="noopener"
            target="_blank"
          >
            <img src={Wordmark} alt="The University of Arizona" />
          </a>
          <div className="header-button-wrap">
            <Button
              linkId="apply-header-cta"
              link="https://slate.admissions.arizona.edu/portal/apply-fw"
            >
              Apply
            </Button>
            <Button
              linkId="already-applied-header-cta"
              link="https://nextsteps.arizona.edu/nextsteps/?trackingLink=True&_gl=1*19qqrg1*_gcl_aw*R0NMLjE3MTgyMjM2MTMuQ2p3S0NBandqcVd6QmhBcUVpd0FRbXRnVF9GSUZaeHVldzRkQjcxVzZvQzNUWGlCZ0ZwdHRtZW9qY1NRWkJKS0FvZ29QZFJCWHB0MFdSb0MxWmNRQXZEX0J3RQ..*_gcl_au*MTAwODkwMDQ0LjE3MTY4MzM1NjE.*_ga*Mzc1NjE3MjA4LjE2OTU0MDk1NTA.*_ga_7PV3540XS3*MTcxOTg1OTIyMC40NzcuMS4xNzE5ODYyNjQ3LjAuMC4w"
            >
              Already Applied?
            </Button>
          </div>
        </div>
      </header>
    </div>
  )
}

export default Header
